import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Close(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M11.1592 10.0984C10.8663 9.80547 10.3915 9.80547 10.0986 10.0984C9.80568 10.3913 9.80568 10.8661 10.0986 11.159L16.8161 17.8765L10.0986 24.5941C9.80568 24.8869 9.80568 25.3618 10.0986 25.6547C10.3915 25.9476 10.8663 25.9476 11.1592 25.6547L17.8768 18.9372L24.5943 25.6547C24.8872 25.9476 25.362 25.9476 25.6549 25.6547C25.9478 25.3618 25.9478 24.8869 25.6549 24.5941L18.9374 17.8765L25.6549 11.159C25.9478 10.8661 25.9478 10.3913 25.6549 10.0984C25.362 9.80547 24.8872 9.80547 24.5943 10.0984L17.8768 16.8159L11.1592 10.0984Z" />
    </IconSvg>
  );
}
